<template>
  <VChip variant="outlined" class="shrink-0 font-semibold bg-fg-disabled" density="compact">
    <p>
      {{ t('Appointment') }} <span v-if="count">({{ count }})</span>
    </p>
  </VChip>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface Props {
  count?: number
}

const { t } = useI18n()

defineProps<Props>()
</script>

<style scoped></style>
